import { PrivacyBody } from "../public/privacy";

// In-app Privacy Policy (Platform Owner → Settings → Privacy Policy).
const PrivacyPage = () => (
  <div className="dashboard">
    <section className="panel">
      <div className="panel__head">
        <div>
          <h2>Privacy Policy</h2>
        </div>
      </div>
      <div className="panel__body">
        <PrivacyBody />
      </div>
    </section>
  </div>
);

export default PrivacyPage;
